import React, { useEffect, useMemo, useState } from 'react';

import { viewParticipantPastVisit } from '../../../../../services/ParticipantService';

import { Table } from '../../../../common/table/Table';
import { PastVisit } from './PastVisit';

import './PastVisit.css';

export const PastVisitsSearch = ({
  participant,
  setParticipant,
  context,
  showToaster,
  setSpinnerText,
  toolTipsEnabled,
}) => {
  const [searchResults, setSearchResults] = useState([]);
  const [showVisitDetails, setShowVisitDetails] = useState(false);
  const [visit, setVisit] = useState(false);

  useEffect(() => {
    setSearchResults(participant?.pastVisits);
  }, [participant]);

  const handleRowClick = (visitToView) => {
    if (visitToView.externalReference) {
      const retrieveVisitRequest = {
        visitExternalReference: visitToView.externalReference,
      };
      retrieveVisit(retrieveVisitRequest).then(() => setShowVisitDetails(true));
    }
  };

  const retrieveVisit = async (retrieveVisitRequest) => {
    setSpinnerText('Retrieving Visit');
    const [data, error] = await viewParticipantPastVisit(context.username, retrieveVisitRequest);
    if (data) {
      if (data.responseStatus === 'Success') {
        setVisit(data.visitVO);
        showToaster({
          responseStatus: 'Success',
          responseMessage: 'Visit successfully retrieved.',
        });
      } else {
        showToaster(data);
      }
    } else {
      showToaster({
        responseStatus: 'Error',
        responseMessage: error.message,
      });
    }
    setSpinnerText(null);
  };

  const hasMissedVisit = useMemo(() => searchResults.some((visit) => visit.missedVisit), [searchResults]);

  return (
    <div>
      {!showVisitDetails && (
        <div className="visit-search">
          {searchResults && (
            <>
              <Table
                tableData={searchResults}
                hiddenColumns={['externalReference', 'missedVisit']}
                onRowClick={handleRowClick}
                tableTitle="Visits"
                maxRowCount={6}
                highlightExpression={(object) => object.missedVisit}
                highlightColor="#F8ACAC"
                searchEnabled
                filterEnabled
                horizontalScroll
              />

              {hasMissedVisit && <p className="visit-search-message">*Missed Visits</p>}
            </>
          )}
        </div>
      )}
      {showVisitDetails && (
        <PastVisit
          participant={participant}
          setParticipant={setParticipant}
          context={context}
          showToaster={showToaster}
          setSpinnerText={setSpinnerText}
          toolTipsEnabled={toolTipsEnabled}
          setShowVisitDetails={setShowVisitDetails}
          visit={visit}
          setSearchResults={setSearchResults}
        />
      )}
    </div>
  );
};
